import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=5bdd8a59&scoped=true&"
import script from "./SelectLang.vue?vue&type=script&lang=js&"
export * from "./SelectLang.vue?vue&type=script&lang=js&"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=5bdd8a59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd8a59",
  null
  
)

export default component.exports